import { render, staticRenderFns } from "./BcAutocomplete.vue?vue&type=template&id=09b1882f"
import script from "./BcAutocomplete.vue?vue&type=script&lang=js"
export * from "./BcAutocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports